import { useDrives } from '@/stores/useDrives.ts'
import { useNavigate } from 'react-router-dom'
import { Template } from '@/models/drawing/drawingTypes.ts'
import DriveHeader from '@/components/DriveHeader.tsx'
import DrawingTemplateRenderer from '@/components/drawing/DrawingTemplateRenderer.tsx'
import { HeyDrive } from '@/models/drive.ts'
import { Trans, useTranslation } from 'react-i18next'
import useDrawingTemplates from '@/hooks/useDrawingTemplates.tsx'

export default function CardsPage() {
  const { currentDrive } = useDrives()
  const { t } = useTranslation()
  const drawingTemplates = useDrawingTemplates()

  return <div>
    <DriveHeader description={null} title={null} />
    <div className="container mx-auto px-4 flex flex-col gap-3 justify-center overflow-hidden items-center pb-5">
      <h2 className='font-serif text-center text-3xl'>{t('common.instantCards')}</h2>
      <div className='grid grid-cols-2 md:grid-cols-3 md:gap-3'>
        { drawingTemplates.map((template, i) => <InstantCardElement drive={currentDrive!} key={i} template={template} />)}
      </div>
      <h2 className='font-serif text-center text-3xl'>{t('common.adaptableCards')}</h2>
      {/*<p className='mx-auto text-center max-w-[40rem]'>Du kannst gerne jederzeit eines unserer <b>20+ Designs</b> mit Canva aus unseren <b><a className='underline text-primary' target='_blank' href="https://fridaysnap.de/kostenlose-kartendesign-vorlagen-fuer-qr-code-hochzeitsfotos/">Hochzeits-Kartendesign-Vorlagen</a></b> oder  <b><a target='_blank' className='text-primary underline' href="https://fridaysnap.de/kostenlose-kartendesign-vorlagen-fuer-qr-code-geburtstags-fotos/">Geburtstags-Kartendesign-Vorlagen</a></b> erstellen. Dort bitte deinen QR-Code aus der Galerie einfügen.</p><br/>*/}
      <p className='mx-auto text-center max-w-[40rem]'><Trans i18nKey='common.cardUseDesigns'>
        <a className='underline text-primary' target='_blank' href="https://fridaysnap.de/kostenlose-kartendesign-vorlagen-fuer-qr-code-hochzeitsfotos/" />
        <a target='_blank' className='text-primary underline' href="https://fridaysnap.de/kostenlose-kartendesign-vorlagen-fuer-qr-code-geburtstags-fotos/" />
      </Trans></p><br/>
    </div>
  </div>
}

function InstantCardElement({template, drive}: { template: Template, drive: HeyDrive }) {
  const navigate = useNavigate()

  return <div onClick={() => navigate(`/d/${drive.id}/cards/${template.id}`)}>
    <div className='w-[8rem] md:w-[12rem] h-[11.35rem] md:h-[17rem] p-2'>
      <DrawingTemplateRenderer template={template} elementOverrides={{ elements: [
        { elementId: 'qr-code', imgSrc: drive.qr_code_image || undefined },
        { elementId: 'names-text', text: drive.title },
        ]}} />
    </div>
  </div>
}
